import React from "react";


function Filter(props) {
    return (
        <select className="filter" name={props.name} defaultValue={props.defaultValue} onChange={(event) => props.onChange(event)} id={props.id} value={props.value} defaultValue={props.defaultValue} aria-label={props.ariaLabel}>
            {props.options.map((option, index) => {
                return (
                    <option key={index} value={option}>{option}</option>
                )
            })}
        </select>

    )
}

export default Filter